import { render } from "./AddTypeNotificationPage.vue?vue&type=template&id=3959238b&ts=true"
import script from "./AddTypeNotificationPage.vue?vue&type=script&lang=ts"
export * from "./AddTypeNotificationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__